export const dataClassifiedStatic = {
    "CurrentUserSession": {
        "Access_Token": "f437cdd6-278b-496e-b269-c7168fbbb731",
        "BasfUser": false,
        "Basket": null,
        "CanUseOrderSample": true,
        "Country": "France",
        "CountryCode": "FR",
        "Email": "patrick.brill.fr@basfqa.com",
        "FederationLogin": true,
        "Firstname": "Patrick",
        "IsLoggedIn": true,
        "LastUpdated": "/Date(1593100173495+0200)/",
        "Lastname": "Brill-FR",
        "LoginMessage": "successful",
        "Region": "FRA",
        "SessionID": "alommpzmpju5jxk1pcj5tmb1",
        "UserId": "0a675dde-697a-44c5-b4b8-0822f6ac8247",
        "UserRights": [
            "CanUseOrderSample"
        ],
        "WALogin": false
    },
    "Items": [
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Ethylhexyl Palmitate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527826",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® C 24",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527826",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "MEDIUM"
            },
            "Title": "Cegesoft C 24"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Passiflora Incarnata Seed Oil",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530129",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® PFO",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530129",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "HIGH",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "VERY HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "HIGH"
            },
            "SensoricData": {
                "Gliding": "LOW",
                "RoCushiony": "HIGH",
                "RoDistribution": "MEDIUM",
                "RoOil": "MEDIUM",
                "Smoothness": "HIGH",
                "Stickiness": "MEDIUM",
                "Thickness": "VERY HIGH",
                "TiPowdery": "LOW",
                "TiResidue1": "HIGH",
                "TiResidue2": "LOW",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Cegesoft PFO"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Olus Oil",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530119",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® PS 6",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530119",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "HIGH",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "VERY HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "VERY HIGH"
            },
            "SensoricData": {
                "Gliding": "LOW",
                "RoCushiony": "VERY HIGH",
                "RoDistribution": "MEDIUM",
                "RoOil": "MEDIUM",
                "Smoothness": "MEDIUM",
                "Stickiness": "HIGH",
                "Thickness": "HIGH",
                "TiPowdery": "LOW",
                "TiResidue1": "HIGH",
                "TiResidue2": "HIGH",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Cegesoft PS 6"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Butyrospermum Parkii Butter",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530126",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® SBE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530126",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cegesoft SBE"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Shorea Stenoptera Seed Butter",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530130",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® SH",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530130",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "HIGH",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cegesoft SH"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Olus Oil (and) Hydrogenated Vegetable Oil (and) Candelilla Cera",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530125",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® VP",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530125",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cegesoft VP"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Ethylhexyl Stearate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527925",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® 868",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527925",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "VERY HIGH",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "LOW",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "LOW",
                "TiWaxdry": "LOW",
                "Wetness": "HIGH"
            },
            "Title": "Cetiol 868"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dipropylheptyl Carbonate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30543500",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® 4 All",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30543500",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "LOW",
                "TiWaxdry": "HIGH",
                "Wetness": "HIGH"
            },
            "Title": "Cetiol 4 All"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyl Laurate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527770",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® A",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527770",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "VERY HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "VERY HIGH",
                "Stickiness": "LOW",
                "Thickness": "MEDIUM",
                "TiPowdery": "HIGH",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "HIGH",
                "Wetness": "MEDIUM"
            },
            "Title": "Cetiol A"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "C12-15 Alkyl Benzoate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30531263",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® AB",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30531263",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "VERY HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "LOW",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "HIGH",
                "Wetness": "MEDIUM"
            },
            "Title": "Cetiol AB"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dibutyl Adipate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527825",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® B",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527825",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "VERY HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "HIGH",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "HIGH",
                "Wetness": "HIGH"
            },
            "Title": "Cetiol B"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Coco-Caprylate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30538241",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® C 5",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30538241",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "LOW",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "LOW",
                "Wetness": "VERY HIGH"
            },
            "Title": "Cetiol C 5"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Coco-Caprylate/Caprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30583738",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® C 5C",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30583738",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "LOW",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "LOW",
                "Wetness": "VERY HIGH"
            },
            "Title": "Cetiol C 5C"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dicaprylyl Carbonate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527869",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® CC",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527869",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "HIGH",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "LOW",
                "Wetness": "HIGH"
            },
            "Title": "Cetiol CC"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "MEDIUM",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "PPG-15 Stearyl Ether",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30536786",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® E",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30536786",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "VERY HIGH",
                "EquivalentAlkaneCarbonNumber": "MEDIUM",
                "InterfacialTension": "LOW",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "VERY HIGH"
            },
            "SensoricData": {
                "Gliding": "LOW",
                "RoCushiony": "VERY HIGH",
                "RoDistribution": "HIGH",
                "RoOil": "MEDIUM",
                "Smoothness": "HIGH",
                "Stickiness": "VERY HIGH",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "VERY HIGH",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "LOW",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Cetiol E"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Oleyl Erucate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527949",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® J 600",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527949",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "MEDIUM",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "VERY HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "MEDIUM"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "LOW",
                "TiWaxdry": "MEDIUM",
                "Wetness": "MEDIUM"
            },
            "Title": "Cetiol J 600"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Coco-Caprylate/Caprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527919",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® LC",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527919",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "VERY HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "VERY HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "VERY HIGH",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "LOW",
                "Wetness": "HIGH"
            },
            "Title": "Cetiol LC"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Myristyl Myristate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527882",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® MM",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527882",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "MEDIUM",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cetiol MM"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dicaprylyl Ether",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527880",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® OE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527880",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "HIGH",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "HIGH",
                "Wetness": "VERY HIGH"
            },
            "Title": "Cetiol OE"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyldecanol (and) Hexyldecyl Laurate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527765",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® PGL",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527765",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "MEDIUM",
                "Thickness": "MEDIUM",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "MEDIUM"
            },
            "Title": "Cetiol PGL"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Caprylyl Caprylate/Caprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30538648",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® RLF",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30538648",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "HIGH",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "VERY HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "VERY HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "VERY HIGH",
                "TiResidue1": "LOW",
                "TiResidue2": "HIGH",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "HIGH"
            },
            "Title": "Cetiol RLF"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Butyrospermum Parkii Butter",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527965",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® SB 45",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527965",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "HIGH",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cetiol SB 45"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "MEDIUM",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Propylheptyl Caprylate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30535766",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® SENSOFT",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30535766",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "HIGH",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "LOW",
                "TiResidue2": "LOW",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "HIGH",
                "Wetness": "VERY HIGH"
            },
            "Title": "Cetiol Sensoft"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Cetearyl Isononanoate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527789",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® SN",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527789",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "HIGH",
                "RoOil": "HIGH",
                "Smoothness": "VERY HIGH",
                "Stickiness": "MEDIUM",
                "Thickness": "MEDIUM",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "MEDIUM",
                "Wetness": "LOW"
            },
            "Title": "Cetiol SN"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Undecane (and) Tridecane",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30597825",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® ULTIMATE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30597825",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "MEDIUM",
                "InterfacialTension": "VERY HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "VERY HIGH",
                "SurfaceTension": "MEDIUM",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "MEDIUM",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "LOW",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "VERY HIGH",
                "TiResidue1": "LOW",
                "TiResidue2": "LOW",
                "TiSiliconeOilFeel": "VERY HIGH",
                "TiWaxdry": "VERY HIGH",
                "Wetness": "VERY HIGH"
            },
            "Title": "Cetiol Ultimate"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Decyl Oleate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527917",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® V",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527917",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "VERY HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "HIGH",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "MEDIUM"
            },
            "Title": "Cetiol V"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Octyldodecanol",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527896",
                    "Preservatives": null,
                    "Product_Name": "EUTANOL® G",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527896",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "HIGH",
                "Viscosity": "HIGH"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "VERY HIGH",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "HIGH",
                "TiPowdery": "LOW",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "LOW"
            },
            "Title": "Eutanol G"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyldecanol",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527771",
                    "Preservatives": null,
                    "Product_Name": "EUTANOL® G 16",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527771",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "LOW",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "HIGH",
                "Viscosity": "MEDIUM"
            },
            "SensoricData": {
                "Gliding": "MEDIUM",
                "RoCushiony": "HIGH",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "HIGH",
                "Wetness": "MEDIUM"
            },
            "Title": "Eutanol G 16"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyldecyl Stearate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527811",
                    "Preservatives": null,
                    "Product_Name": "EUTANOL® G 16 S",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527811",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "MEDIUM",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "MEDIUM"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "HIGH",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "HIGH",
                "TiResidue2": "HIGH",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Eutanol G 16 S"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Isopropyl Myristate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527973",
                    "Preservatives": null,
                    "Product_Name": "ISOPROPYL MYRISTATE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527973",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "HIGH",
                "Wetness": "VERY HIGH"
            },
            "Title": "IPM"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Isopropyl Palmitate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30528720",
                    "Preservatives": null,
                    "Product_Name": "ISOPROPYL PALMITATE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30528720",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "VERY HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "MEDIUM",
                "Wetness": "HIGH"
            },
            "Title": "IPP"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hydrogenated Polyisobutene",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30674105",
                    "Preservatives": null,
                    "Product_Name": "LUVITOL® LITE EM",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30674105",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "VERY HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "HIGH",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "LOW",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "LOW",
                "TiWaxdry": "HIGH",
                "Wetness": "VERY HIGH"
            },
            "Title": "Luvitol Lite"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Caprylic/Capric Triglyceride",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527793",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® 312",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527793",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "MEDIUM",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "MEDIUM"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "MEDIUM",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Myritol 312"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Caprylic/Capric Triglyceride",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527906",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® 318",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527906",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "MEDIUM",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "MEDIUM",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "MEDIUM",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "MEDIUM"
            },
            "Title": "Myritol 318"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Cocoglycerides",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527787",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® 331",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527787",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "MEDIUM",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "LOW",
                "RefractiveIndex": "HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "MEDIUM"
            },
            "SensoricData": {
                "Gliding": "MEDIUM",
                "RoCushiony": "HIGH",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "MEDIUM",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "HIGH",
                "TiResidue2": "HIGH",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Myritol 331"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Propylene Glycol Dicaprylate/ Dicaprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30565451",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® PGDC",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30565451",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "HIGH",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "VERY HIGH",
                "RoOil": "HIGH",
                "Smoothness": "VERY HIGH",
                "Stickiness": "MEDIUM",
                "Thickness": "MEDIUM",
                "TiPowdery": "LOW",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "HIGH",
                "TiWaxdry": "HIGH",
                "Wetness": "MEDIUM"
            },
            "Title": "Myritol PGDC"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Isononyl Isononanoate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30682806",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® ININ-GL",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30682806",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "MEDIUM",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "HIGH",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "VERY HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "LOW",
                "TiResidue1": "LOW",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "HIGH"
            },
            "Title": "Cetiol ININ"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "VERY HIGH",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Cetyl Palmitate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527819",
                    "Preservatives": null,
                    "Product_Name": "CUTINA® CP",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527819",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "MEDIUM",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cutina CP"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": null,
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "LOW",
                "Spreadability": "MEDIUM",
                "SurfaceTension": "LOW",
                "Viscosity": "LOW"
            },
            "SensoricData": {
                "Gliding": "HIGH",
                "RoCushiony": "LOW",
                "RoDistribution": "VERY HIGH",
                "RoOil": "VERY HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "LOW",
                "Thickness": "LOW",
                "TiPowdery": "HIGH",
                "TiResidue1": "LOW",
                "TiResidue2": "LOW",
                "TiSiliconeOilFeel": "VERY HIGH",
                "TiWaxdry": "VERY HIGH",
                "Wetness": "VERY HIGH"
            },
            "Title": "Cyclomethicone"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": null,
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "VERY HIGH",
                "EquivalentAlkaneCarbonNumber": "VERY HIGH",
                "InterfacialTension": "HIGH",
                "RefractiveIndex": "LOW",
                "Spreadability": "LOW",
                "SurfaceTension": "LOW",
                "Viscosity": "VERY HIGH"
            },
            "SensoricData": {
                "Gliding": "MEDIUM",
                "RoCushiony": "VERY HIGH",
                "RoDistribution": "LOW",
                "RoOil": "LOW",
                "Smoothness": "LOW",
                "Stickiness": "MEDIUM",
                "Thickness": "VERY HIGH",
                "TiPowdery": "LOW",
                "TiResidue1": "HIGH",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "LOW",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Dimethicone (100 Cst)"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": null,
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "VERY HIGH",
                "RefractiveIndex": "VERY HIGH",
                "Spreadability": "LOW",
                "SurfaceTension": "VERY HIGH",
                "Viscosity": "MEDIUM"
            },
            "SensoricData": {
                "Gliding": "MEDIUM",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "HIGH",
                "RoOil": "HIGH",
                "Smoothness": "MEDIUM",
                "Stickiness": "MEDIUM",
                "Thickness": "HIGH",
                "TiPowdery": "LOW",
                "TiResidue1": "HIGH",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "HIGH",
                "Wetness": "LOW"
            },
            "Title": "Light Paraffin Oil"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "LOW",
                "RelatedProduct": null,
                "Tags": null,
                "UrlName": null
            },
            "PhysicalData": {
                "AverageMolecularWeight": "LOW",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "LOW",
                "SurfaceTension": "",
                "Viscosity": "MEDIUM"
            },
            "SensoricData": {
                "Gliding": "MEDIUM",
                "RoCushiony": "MEDIUM",
                "RoDistribution": "HIGH",
                "RoOil": "HIGH",
                "Smoothness": "HIGH",
                "Stickiness": "LOW",
                "Thickness": "MEDIUM",
                "TiPowdery": "MEDIUM",
                "TiResidue1": "MEDIUM",
                "TiResidue2": "MEDIUM",
                "TiSiliconeOilFeel": "MEDIUM",
                "TiWaxdry": "MEDIUM",
                "Wetness": "MEDIUM"
            },
            "Title": "White Paraffin Oil"
        }
    ]
}
